/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { InjectionToken } from '@angular/core';

export const BREADCRUMB_NAME$ = new InjectionToken<string>('breadcrumbName$');

export const BREADCRUMB_DESCRIPTION$ = new InjectionToken<string>('breadcrumbDescription$');
